var map = {
	"./404.svg": "a14a",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide 2.svg": "2027",
	"./guide.svg": "6683",
	"./icon-PDF.svg": "861b",
	"./icon-excel.svg": "27dd",
	"./icon-jpg.svg": "32ba",
	"./icon-txt.svg": "3dc2",
	"./icon-unknown.svg": "0d78",
	"./icon-word.svg": "d956",
	"./icon-zip.svg": "6103",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./logo.svg": "bb69",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./qq.svg": "1430",
	"./search.svg": "8e8d",
	"./setup.svg": "9f61",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./star.svg": "708a",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";